import React from "react";


export const AppLayouts = {layout1 :React.lazy(() => import('./Layout1/Layout1'))}